import { AnchorBox } from '@vfit/shared/atoms';
import { Children } from 'react';
import { purify } from '@vfit/shared/themes';
import { IAnchorsList } from './AnchorsList.models';
import { AnchorsContainer, MainContainer, Title } from './AnchorsList.style';

const AnchorsList = ({ title, isDarkMode = false, anchors }: IAnchorsList): JSX.Element => {
  const [pTitle] = purify([title]);

  const renderAnchors = () =>
    Children.toArray(
      anchors
        ?.filter((el) => !!el.anchorLink && !!el.anchorLabel)
        ?.map((el) => (
          <AnchorBox
            isDarkMode={isDarkMode}
            anchorLabel={el.anchorLabel}
            anchorLink={el.anchorLink}
          />
        ))
    );

  return (
    <MainContainer>
      {pTitle && <Title darkMode={isDarkMode} dangerouslySetInnerHTML={{ __html: pTitle }} />}
      <AnchorsContainer>{renderAnchors()}</AnchorsContainer>
    </MainContainer>
  );
};

export default AnchorsList;
